// Whether this session row has a recording that Delete Recording and Delete All Recordings may
// remove. One predicate for the Select Replay checkbox and both buttons on the user sessions page,
// replacing three inline copies that disagreed on type: the "Delete All Recordings" filter and
// its enabled state ignored it, the checkbox required it.
//
// Keys on replay_url and never on status. A recording outlives a status change: Care cancelled a
// class after its recording was already published, so the CANCELLED row still holds replay_url and
// the recording is real (PROD-10327). The earlier `status === 'FINISHED'` check was a stand-in for
// "has a recording" (commit 9def9bd3) and locked those rows out. The delete endpoint itself
// selects on `replay_url IS NOT NULL AND replay_url != ''` whatever the status (goserver
// crons_tasks/api_delete_recordings.go:40), so adding a status test here only hides rows the
// server would delete.
//
// YOGA (1on1) only. A group class's recording is one S3 file whose replay_url goserver writes onto
// the class row and every non-cancelled member's row in one update (crons_tasks/transcript_actions.go,
// `id = ? OR group_session_id = ?` and `status != 'CANCELLED'`), so deleting it from one student's
// row deletes it for the whole class. The type check came in commit 54388a81, "disable checkbox for
// group class". The bulk endpoint clear_all_recordings_for_student also deletes only `type = YOGA`
// rows (api_delete_recordings.go:96), so the Delete All Recordings button follows the same type rule
// as that endpoint: never loosen this to "any type with a replay_url". The page judges only the rows
// it loaded (100 per page) while the endpoint deletes across all of the student's sessions.
//
// The Replay column does not use this: it answers "does a recording exist" for every type and tests
// replay_url alone (index.jsx), and a group row has a recording that must still not be deleted here.
export interface RecordedSession {
  replay_url?: string | null;
  type?: string;
}

export const hasDeletableRecording = (session: RecordedSession): boolean =>
  !!session.replay_url && session.type === 'YOGA';
